module.exports = "build/fonts/info.svg";